/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Electronically/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function Electronically({
  children,
  viewPath = "/DesignSystem/DataVaxiomInsuranceCarrierForm/Electronically",
  onChange
  
}) {
let carrierElectronicValueData = fromData.useDataValue({ viewPath,
context: 'carrier',
path: 'electronic',
})
let carrierElectronicChangeData = fromData.useDataChange({ viewPath,
context: 'carrier',
path: 'electronic',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="carrier.electronic"
 value={carrierElectronicValueData}
 onChange={carrierElectronicChangeData}
 marginTop={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Submit Electronically"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}